import BaseApi from './BaseApi';
import { ApiPaths } from './ApiPaths';

/**
 * API for retrieving and sending messages
 */
const create = () => { 

    const api = BaseApi.create();

    const getCaseMessages = () => api.get(ApiPaths.MESSAGES);
    const sendMessage = (message) => api.post(ApiPaths.MESSAGES, {comment: message});
    const setMessagesLastReadDate = () => api.post(ApiPaths.MESSAGES_READ, '');
    const sendInternalNoteNoPrinter = (payload) => api.post(ApiPaths.MESSAGES_INTERNAL_NOTE_NO_PRINTER, payload);

  // Return back a collection of functions
  return {
      getCaseMessages, sendMessage, setMessagesLastReadDate, sendInternalNoteNoPrinter
  }
}

// let's return back our create method as the default.
export default {
  create
}